import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class FeatureForHouseType{
	constructor(props){
		const {getFeatureById, featureId}=props;
		this._getFeatureById= getFeatureById;
		this._featureId = featureId;
		
	}
	get feature(){
		return this._getFeatureById(this._featureId);
	}
	get featureId(){
		return this._featureId;
	}
}
